import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from './actions'
import { useParams, useHistory } from 'react-router-dom'
import { InitialState } from './types'
import Cookies from 'js-cookie'
import { useAlert } from 'react-alert'
import ym from 'react-yandex-metrika'

// Components
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import LoadingPage from '../../components/LoadingPage'
import ProgressBlock from '../../components/ProgressBlock'
import MapBlock from '../../components/MapBlock'
import MapHelperBlock from '../../components/MapHelperBlock'
import ButtonStart from '../../components/ButtonStart'
import FinishedCourseBlock from '../../components/FinishedCourseBlock'

export default () => {
  const [isStart, setIsStart] = useState<boolean>(false)
  const [joinModuleId, setJoinModuleId] = useState<string>('')
  const [disabledButton, setDisabledButton] = useState<boolean>(true)
  const [isCourseFinished, setIsCourseFinished] = useState<boolean>(false)

  const [pageLoaded, setPageLoaded] = useState<boolean>(false)

  const prefix = process.env.REACT_APP_URI_PREFIX

  const isAuthed = !!Cookies.get('token')
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const alert = useAlert()

  const { page, progress, error, isCourseJoined } = useSelector(
    (state: { coursePage: InitialState }) => state.coursePage
  )

  useEffect(() => {
    if (error) {
      alert.error(error)
    }
  }, [error])

  useEffect(() => {
    dispatch(actions.destroy())
    dispatch(actions.fetchCoursePage(id))
    if (isAuthed) {
      dispatch(actions.fetchCourseUserState(id))
    }
    return () => {
      dispatch(actions.destroy())
    }
  }, [])

  useEffect(() => {
    if (page && page.modules?.length) {
      const hasStartedModules = page.modules.some(module => module.is_joined)
      if (hasStartedModules) {
        setIsStart(false)
      } else {
        setIsStart(true)
      }

      if (
        page.user_course?.finished_at !== null &&
        page.user_course?.received_at === null
      ) {
        setIsCourseFinished(true)
      } else {
        setIsCourseFinished(false)
      }

      const countContinueModules = page.modules.filter(
        module =>
          (!module.is_finished &&
            module.is_joined &&
            module.is_available_on_time &&
            !module.is_blocked) ||
          (!module.is_finished &&
            module.can_join &&
            module.is_available_on_time &&
            !module.is_blocked) ||
          module.module_lessons.find(lesson => lesson.can_complete)
      ).length

      const isJoinedCourse = !!page.user_course

      setDisabledButton(!countContinueModules && isJoinedCourse && isAuthed)
      setPageLoaded(true)
    }
  }, [page])

  useEffect(() => {
    if (joinModuleId) {
      const findModule = page?.modules.find(
        module => module.module_id === joinModuleId
      )
      const firstScreenId = findModule?.module_screens?.find(
        screen => screen.type === 'first'
      )?.module_screen_id
      const isJoined = findModule?.is_joined
      if (isJoined) {
        history.push(`/courses/${id}/modules/${joinModuleId}`)
      } else {
        dispatch(actions.joinModule(id, joinModuleId, firstScreenId))
      }
    }
  }, [joinModuleId])

  const handleStart = (isContinueMetrika: boolean) => {
    if (isAuthed) {
      if (page && (page.user_course || isCourseJoined)) {
        if (isStart) {
          const firstModuleId = page.modules[0]?.module_id
          if (firstModuleId) {
            ym('reachGoal', 'start_labirint_registered')
            setJoinModuleId(firstModuleId)
          }
        } else {
          if (isContinueMetrika) {
            ym('reachGoal', 'continue_labirint')
          }
          const continueModuleId = page?.modules.find(
            module =>
              (!module.is_finished &&
                module.is_joined &&
                module.is_available_on_time &&
                !module.is_blocked) ||
              (!module.is_finished &&
                module.can_join &&
                module.is_available_on_time &&
                !module.is_blocked) ||
              module.can_complete
          )?.module_id

          if (continueModuleId) {
            setJoinModuleId(continueModuleId)
          }
        }
      } else {
        ym('reachGoal', 'start_labirint_registered')
        dispatch(actions.joinCourse(id))
      }
    } else {
      ym('reachGoal', 'start_labirint')
      const location = document.location.pathname.replace(prefix, '')
      history.push(`/signin?redirect_uri=${location}`)
    }
  }

  useEffect(() => {
    if (isCourseJoined) {
      handleStart(false)
    }
  }, [isCourseJoined])

  return (
    <>
      <Header />
      <div className={'container'}>
        {page && page.active_map && pageLoaded ? (
          <>
            {progress ? (
              <ProgressBlock
                title={'Прогресс курса: '}
                percent={progress.progress?.other?.percent}
                style={{ marginBottom: 27 }}
              />
            ) : null}
            {isCourseFinished ? (
              <FinishedCourseBlock
                image={page.active_map.image_media.url}
                title={page.title}
                onClickButton={() => dispatch(actions.repayCourse(id))}
              />
            ) : (
              <>
                <MapBlock
                  image={page.active_map.image_media.url}
                  style={{ marginBottom: 25 }}
                  markers={page.active_map.markers}
                  themes={page.themes}
                  modules={page.modules}
                />
                <div className={'map-buttons-container'}>
                  <MapHelperBlock style={{ marginRight: 32 }} />
                  <ButtonStart
                    disabled={disabledButton}
                    title={isStart ? 'Начать' : 'Продолжить'}
                    onClick={() => handleStart(true)}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <LoadingPage />
        )}
        {error ? <span style={{ color: 'red' }}>{error}</span> : null}
      </div>
      <Footer />
    </>
  )
}
